export default defineAppConfig({
  ui: {
    primary: 'indigo',
    icons: {
      external: 'i-ph-arrow-up-right',
    },
  },
});
